import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { EditProfiloModalComponent } from './edit-profilo-modal';

export const EditProfiloModalModule: string = ng
    .module('archiSmall.components.editProfiloModalModule', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('editProfiloModalComponent', EditProfiloModalComponent)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/commons/components/edit-profilo-modal/edit-profilo-modal.module.ts